//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';

export default {
	data () {
		return {
			selectedPartyType: '',
		};
	},

	async fetch () {
		try {
			const response = await this.$axios.get('/party/party-themes');
			await this.$store.commit('party/SET_PARTY_THEMES', response.data.payload);

		}
		catch (e) {
			this.$nuxt.error({
				statusCode: 404,
				message: 'Unable to fetch party themes at this time. Please try again.',
			});
		}
	},

	head () {
		return {
			title: this.$config.webTitle[this.$i18n.locale] + ' - Chystám party',
			meta: [
				{
					name: 'description',
					content: this.$config.webDescription[this.$i18n.locale],
				},
				{
					property: 'og:title',
					content: this.$config.webTitle[this.$i18n.locale],
				},
				{
					property: 'og:description',
					content: this.$config.webDescription[this.$i18n.locale],
				},
			],
		};
	},

	computed: {
		...mapState({
			partyItems: (state) => state.party.partyThemes,
		}),
	},

	methods: {
		filterPartyItems (value) {
			this.selectedPartyType = value;
			this.$axios.get('/party/party-themes?' + value + '=true').then(response => {
				this.$store.commit('party/SET_PARTY_THEMES', response.data.payload);
			});
		},

		resetFilter () {
			this.$axios.get('/party/party-themes').then(response => {
				this.$store.commit('party/SET_PARTY_THEMES', response.data.payload);
				this.selectedPartyType = '';
			});
		},
	},
};
